import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Warehouse, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import DijitalRoketFooter from "@/components/common/DijitalRoketFooter";
import Logo from "@/components/common/Logo";

export default function StockLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = async () => { await logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-slate-950 grain-bg flex-1 flex flex-col w-full">
      <header className="sticky top-0 z-40 border-b border-slate-800 bg-slate-950/85 backdrop-blur-xl h-14 sm:h-16">
        <div className="max-w-[1600px] mx-auto px-3 sm:px-4 lg:px-6 h-full flex items-center gap-2 sm:gap-4">
          <Link to="/stok" data-testid="logo-home-link" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity min-w-0">
            <Logo size="sm" />
            <div className="hidden xs:block text-[10px] uppercase tracking-widest text-slate-500 border-l border-slate-800 pl-2 sm:pl-3 truncate">Stok<br/>Paneli</div>
          </Link>
          <nav className="ml-auto flex items-center gap-1 sm:gap-2">
            <NavLink to="/stok" end data-testid="nav-stock" className={({ isActive }) =>
              `px-2 sm:px-3 py-2 text-sm rounded-sm flex items-center gap-2 ${isActive ? "text-red-500" : "text-slate-300 hover:text-slate-50"}`}>
              <Warehouse className="w-4 h-4" /> <span className="hidden sm:inline">Stok</span>
            </NavLink>
            <div className="hidden md:block text-xs text-slate-400 ml-2 truncate max-w-[180px]">{user?.email}</div>
            <Button variant="ghost" onClick={handleLogout} data-testid="logout-button"
              className="text-slate-300 hover:bg-red-900/30 hover:text-red-400 px-2 sm:px-3">
              <LogOut className="w-4 h-4 sm:mr-2" /> <span className="hidden sm:inline">Çıkış</span>
            </Button>
          </nav>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-3 sm:px-4 lg:px-6 py-4 sm:py-6 w-full flex-1 min-w-0">
        <Outlet />
      </main>
      <footer className="border-t border-slate-800 py-4 px-3 sm:px-4 lg:px-6 mt-auto">
        <div className="max-w-[1600px] mx-auto">
          <DijitalRoketFooter compact />
        </div>
      </footer>
    </div>
  );
}
